module.exports = __webpack_public_path__ + "img/pr-9.f90b1fe9.png";